import { render, staticRenderFns } from "./GroupsFilterByRule.vue?vue&type=template&id=2b58e484"
import script from "./GroupsFilterByRule.vue?vue&type=script&lang=js"
export * from "./GroupsFilterByRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports